import * as React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { navigateTo } from '../../../../actions/navigationActions';
import { updateCarCover } from '../../../../actions/salesActions';
import { QUOTATION } from '../../../../routes/routes';
import './SwapAgreedValuePage.css'

class SwapAgreedValuePage extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            retailValue: 176300
        };
        this.handleClickNo = this.handleClickNo.bind(this);
        this.handleClickYes = this.handleClickYes.bind(this);
    }

    async handleClickNo() {
        await this.props.dispatchAction(navigateTo(QUOTATION));
    }

    async handleClickYes() {
        await this.props.dispatchAction(updateCarCover(true, true));
    }

    public render() {
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 pb-5 logged-in" : "pt-lg-5 pb-5 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={100} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="">
                                <div className="mt-5 text-center">
                                    <img src="./images/OnlineQuotation/crown-icon.png" className="img-fluid" alt="" />
                                </div>
                                <div className="mt-44px">
                                    <p className="text-center"><b>The retail value of your car is:</b></p>
                                </div>
                                <div className="row mt-5 mb-5 justify-content-center">
                                    <div className="retail-value-border">
                                        <p className="text-center mt-15px"><b>{this.props.profile.currencySymbol} {this.props.sales.carDetails.retailValue.toFixed(2)}</b></p>
                                    </div>
                                </div>
                                <p className="font-size-16px font-weight-500 text-center noma">Would you like to insure your car for more than its retail value?<img className="raftooltip ml-10px" id="rafTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="agreedValueTooltip" data-tip="" />
                                    <ReactTooltip id="agreedValueTooltip" className="tooltip-gray" place="right" effect="solid" backgroundColor="#3a1826" delayShow={1000}>The agreed value that’s noted on your policy schedule refers to the amount that the car is covered for, for the 3 years following the start of the cover.
                                        This agreed value must be, well, agreed on by you and us.</ReactTooltip>
                                </p>
                                <p className="font-size-16px font-weight-500 text-center">Please select ‘Yes’ for agreed value (which can be up to 20% more than the retail value) or ‘No’ for retail value.</p>
                            </div>
                            <div className="row col-12 justify-content-center">
                                <div className="col-md-6 col-xl-4 col-12 text-right">
                                    <button className="btn btn-outline-red mt-3 w-100 mt-lg-0 cursor-pointer" id="selectAgreedValue" onClick={this.handleClickYes}>Yes</button>
                                </div>
                                <div className="col-md-6 col-xl-4 col-12">
                                    <button className="btn btn-block btn-outline-red w-100 mt-3 mt-lg-0 cursor-pointer" id="selectCompCar" onClick={this.handleClickNo}>No</button>
                                </div>
                            </div>
                            <div className="form-row text-left noma agreed-value-please-note mt-44px">
                                <div className="col-12 nopa">
                                    <p className="mb-0px font-weight-bold">Need to know:</p>
                                </div>
                                <div className="col-12 nopa">
                                    <ul className="mb-0px pl-25px">
                                        <li>If you choose retail value, we’ll give you comprehensive cover with a premium that decreases monthly as your car loses value. So, your car is always covered for what it’s worth. Comprehensive car insurance covers you for accident damage, theft and hi-jacking, and for damage to other people’s property (also called third party liability) as the result of a car accident that you’re involved in.</li>
                                        <li>The only difference between our agreed value and comprehensive options is that, with agreed value, the insured value that’s noted on your policy schedule is the amount that the car is covered for, for 3 years.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SwapAgreedValuePage);